module.exports = __webpack_public_path__ + "assets/img/google-play.db9b21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play.png
// module id = OyA8
// module chunks = 1